/**
 * Intent-moment signup on job detail (PR 5, 2026-10): helpers shared by the
 * post-apply signup card (`src/components/jobs/job-intent-signup.tsx`).
 *
 * The card's arm is now read from the `aha-signup-ask` flag
 * (`src/lib/experiments/aha-signup-ask.ts`), which superseded the
 * `job-intent-signup` flag on 2026-10-30: that flag sat at 0% rollout with
 * zero exposures and nothing reads it any more.
 *
 * WHY THIS IS NOT `apply_signup_gate` AGAIN. That wall was retired on
 * 2026-09-07 (#5113) because `useExperiment` starts on control, control WAS
 * the wall, and 812 people/30d whose flags never resolved were walled by a
 * telemetry failure. Here: (1) the card renders after the apply, never in
 * front of it; (2) control and unresolved both render today's UI; (3) an
 * unresolved read fires NO exposure, so a missing flag is never an arm.
 */

/** Stamped on the post-signup callbackURL; `signup_started.callback_url` and
 * the return handler key off it. */
export const JOB_INTENT_SIGNUP_SRC = "job_intent_signup";

const APPLY_MOMENT_CLAIM_PREFIX = "ld_apply_moment_claim:";

/**
 * One ask per apply. The test arm claims this job's apply moment so
 * `ApplyMomentCvOffer` (same `ld:apply-clicked` trigger) stands down instead
 * of stacking a second card on the same click. Written synchronously inside
 * the event dispatch, so it lands before the offer's post-render effect reads
 * it, whatever the listener order.
 */
export function claimApplyMomentForIntentSignup(jobId: string): void {
	try {
		window.sessionStorage.setItem(APPLY_MOMENT_CLAIM_PREFIX + jobId, "1");
	} catch {
		/* storage blocked: both cards may show, apply is unaffected */
	}
}

export function isApplyMomentClaimed(jobId: string): boolean {
	try {
		return (
			window.sessionStorage.getItem(APPLY_MOMENT_CLAIM_PREFIX + jobId) === "1"
		);
	} catch {
		return false;
	}
}
